import React from 'react';
import {decodeEntities} from '@wordpress/html-entities';
import DOMPurify from "dompurify";
import {  AliasPopup, CheckoutButton } from '.';
import { Popup } from './popup';

const { registerPaymentMethod } = window.wc.wcBlocksRegistry
const { getSetting } = window.wc.wcSettings

const settings = getSetting( 'spgw_bancontact_data', {} );

const { title, alias_manager, save_card_html, icon, description, popupTextTrans } = settings;
const label = decodeEntities( settings.title || '' );
const desc =  DOMPurify.sanitize(description);
const alias = ( alias_manager == 'active' );
const cleanHTML = DOMPurify.sanitize(save_card_html);

const ContentComponent = (props) => {
	const { eventRegistration, emitResponse } = props;
	const { onPaymentSetup } = eventRegistration;
	return (
	  <div>
		<div dangerouslySetInnerHTML={{ __html: desc }} /> <Popup popupTextTrans={popupTextTrans} />
		<CheckoutButton/>
      	<AliasPopup onPaymentSetup={onPaymentSetup}  emitResponse={emitResponse}/>
		<div dangerouslySetInnerHTML={{ __html: cleanHTML }} />{" "}
	  </div>
	);
  };
const Icon = () => {
	return icon 
		? <img alt='' src={icon} style={{ float: 'right', marginRight: '20px' }} /> 
		: '';
};
const Label = () => {
	return (
		<span style={{ width: '100%' }}>
			{title}
			<Icon />
		</span>
	);
};


registerPaymentMethod( {
	name: "spgw_bancontact",
	label: <Label />,
	content: <ContentComponent/>,
	edit: <ContentComponent />,
	canMakePayment: (cart) => {
		if(!settings.availability) {
			return false;
		}
		if(cart.billingAddress.country == "" || (settings.allowedCountries.length == 1 && settings.allowedCountries.includes('select'))) {
			return true;
		}
		if(settings.allowedCountries.length != 0) {
			return settings.allowedCountries.includes(cart.billingAddress.country);
		}
		return true;
	},
	ariaLabel: label,
	supports: {
		features: settings.supports,
		showSavedCards: alias,
		showSaveOption: alias,

	}
} )

